import { createAction } from "@redux/actions/actionCreators";

const [useAddProductOption, addProductOption] = createAction<{
  productUuid: string;
  /** Pre-generated UUID for the new option. */
  id: string;
}>("product/addOption");

export default useAddProductOption;
export { addProductOption };
